module.exports = __webpack_public_path__ + "media/images/top/budget_table/kojin_sp_over1000-75cd6fcadff3f45652f2c82eb4e3c0c3.png";